import React from 'react';
import { ArrowImg, NextPageButtonWrapper, PrevPageButtonWrapper, PageNumberLink } from './PaginationButtons.css.js';
import { getNextSkipAmount, genRandomStr } from '../../helpers/helpers.js';

const generatePrevButton = (basePath, categoryUrl, onSalePageOne, prevString, s3Path, skip, page) => {
  if (skip && !onSalePageOne && page === 'product') {
    return (
      <a href={`${basePath}${categoryUrl || ''}${prevString}`}>
        <PrevPageButtonWrapper>
          <ArrowImg src={`${s3Path}mkt/icon/arrow_left_black.png`} />
        </PrevPageButtonWrapper>
      </a>
    );
  }
  if (skip && !onSalePageOne && page === 'brands') {
    return (
      <a href={`${basePath}${prevString}`}>
        <PrevPageButtonWrapper>
          <ArrowImg src={`${s3Path}mkt/icon/arrow_left_black.png`} />
        </PrevPageButtonWrapper>
      </a>
    );
  }
  return (
    <PrevPageButtonWrapper>
      <ArrowImg src={`${s3Path}mkt/icon/arrow_left_grey.png`} />
    </PrevPageButtonWrapper>
  );
};

const generateNextButton = (basePath, categoryUrl, currentPage, nextString, s3Path, totalPages, page) => {
  if (currentPage < totalPages && page === 'product' && nextString) {
    return (
      <a href={`${basePath}${categoryUrl || ''}${nextString}`}>
        <NextPageButtonWrapper>
          <ArrowImg src={`${s3Path}mkt/icon/arrow_right_black.png`} />
        </NextPageButtonWrapper>
      </a>
    );
  }
  if (currentPage < totalPages && page === 'brands' && nextString) {
    return (
      <a href={`${basePath}${nextString}`}>
        <NextPageButtonWrapper>
          <ArrowImg src={`${s3Path}mkt/icon/arrow_right_black.png`} />
        </NextPageButtonWrapper>
      </a>
    );
  }
  return (
    <NextPageButtonWrapper>
      <ArrowImg src={`${s3Path}mkt/icon/arrow_right_grey.png`} />
    </NextPageButtonWrapper>
  );
};

const generateHref = (page, queryFunction, skipAmount, options) => {
  const { basePath, brand, categoryId, categoryUrl, lang, onSale, skip, query, sortBy } = options;
  if (page === 'product') {
    return `${basePath}${categoryUrl}${queryFunction(onSale, categoryUrl, lang, skipAmount, sortBy, brand, query)}`;
  }
  if (page === 'brands') {
    return `${basePath}${queryFunction(categoryId, categoryUrl, skipAmount, sortBy)}`;
  }
};

const buildPageNumberLinks = params => {
  const {
    basePath,
    brand,
    categoryId,
    categoryUrl,
    currentPage,
    generateQueryString,
    getNextSkipAmount,
    lang,
    onSale,
    page,
    query,
    seedArray,
    sortBy,
    total,
  } = params;
  let offset = 0;
  let skipAmount;

  return seedArray.map(linkNumber => {
    if (currentPage < 5) {
      skipAmount = getNextSkipAmount(offset, total);
      offset += 60;
    } else {
      skipAmount = (linkNumber - 1) * 60;
    }
    return (
      <PageNumberLink
        active={currentPage === linkNumber}
        href={generateHref(page, generateQueryString, skipAmount, params)}
        key={genRandomStr()}
      >
        {`${linkNumber}  `}
      </PageNumberLink>
    );
  });
};

const buildSeedArray = (length, currentPage, isFinalPage) => {
  if (isFinalPage) {
    return [...Array(length)].map((_, i) => currentPage - (length - (i + 1)));
  }
  return [...Array(length)]
    .map((_, i) => {
      if (i + 1 < Math.ceil(length / 2)) {
        return currentPage - (i + 1);
      }
      if (i + 1 === Math.ceil(length / 2)) {
        return currentPage;
      }
      return currentPage + (length - i);
    })
    .sort((a, b) => a - b);
};

const generatePagesNumbers = (currentPage, totalPages) => {
  let seedArray;

  if (currentPage === totalPages) {
    if (totalPages > 5) {
      seedArray = buildSeedArray(5, currentPage, true);
      seedArray = seedArray.slice(0, -1);
    } else {
      seedArray = buildSeedArray(totalPages, currentPage, true);
      if (totalPages > 2 && totalPages <= 5) {
        seedArray = seedArray.slice(0, -1);
        seedArray.shift();
      } else if (totalPages > 2) {
        seedArray = seedArray.slice(0, -1);
      } else {
        seedArray.shift();
      }
    }
  } else if (currentPage >= 6) {
    seedArray = buildSeedArray(5, currentPage);
    if (currentPage === totalPages - 1) {
      seedArray = seedArray.slice(0, -2);
    }
    if (currentPage === totalPages - 2) {
      seedArray = seedArray.slice(0, -1);
    }
  } else if (totalPages >= 7) {
    seedArray = [...Array(7)].map((_, i) => i + 1);
    seedArray.shift();
  } else {
    seedArray = [...Array(totalPages)].map((_, i) => i + 1);
    seedArray.shift();
  }

  return seedArray;
};

const generatePagesLinks = (
  basePath,
  currentPage,
  total,
  totalPages,
  brand,
  categoryId,
  categoryUrl,
  generateQueryString,
  lang,
  onSale,
  page,
  query,
  skip,
  sortBy,
) => {
  //eslint-disable-line
  const seedArray = generatePagesNumbers(currentPage, totalPages);
  return buildPageNumberLinks({
    basePath,
    brand,
    categoryId,
    categoryUrl,
    currentPage,
    generateQueryString,
    getNextSkipAmount,
    lang,
    onSale,
    page,
    query,
    seedArray,
    sortBy,
    total,
  });
};

export { generatePrevButton, generateNextButton, generateHref, generatePagesLinks, generatePagesNumbers };
